export const environment = {
  production: true,
  // apiEndpoint: "https://brave-stone-09007a403.2.azurestaticapps.net",
  apiEndpoint: "https://maps.trip4you.net",
  releaseDate: "2026-11-04",
  releaseVersion: "3.0.142",
  loginWithDevUser: false
};

